export const EXCMCASETYPE_CREATE_RESET = 'EXCMCASETYPE_CREATE_RESET'
export const EXCMCASETYPE_CREATE_SET_CREATED = 'EXCMCASETYPE_CREATE_SET_CREATED'
export const EXCMCASETYPE_CREATE_SET_ERROR = 'EXCMCASETYPE_CREATE_SET_ERROR'
export const EXCMCASETYPE_CREATE_SET_VIOLATIONS = 'EXCMCASETYPE_CREATE_SET_VIOLATIONS'
export const EXCMCASETYPE_CREATE_TOGGLE_LOADING = 'EXCMCASETYPE_CREATE_TOGGLE_LOADING'
